import { defineComponent } from 'vue';
import { Form, FormItem, Input, InputPassword, Button } from 'ant-design-vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { useStoreCaptcha } from '@src/store/modules/captcha';
import type { LoginData } from '@src/api/auth';
import * as api from '@src/api/auth';
import { useStoreLoginModal } from '@src/store/modules/loginModal';
import SvgIcon from '@src/components/SvgIcon';

export default defineComponent({
    name: 'Password',
    emits: ['setKey'],
    setup(props, context) {
        const storeCaptcha = useStoreCaptcha();
        const storeLoginModal = useStoreLoginModal();

        /**
         * data
         */
        const formLoading = ref(false);
        const formState = reactive({
            loginName: '',
            password: '',
            code: '',
        }) as Omit<LoginData, 'uuid'>;
        const formRef = ref();

        /**
         * methods
         */
        const handleSubmit = async () => {
            await formRef.value.validate();
            formLoading.value = true;
            const res = await api
                .login({
                    ...formState,
                    uuid: storeCaptcha.captchaInfo.uuid,
                })
                .catch(() => {
                    storeCaptcha.getCaptchaInfo();
                    throw new Error('验证码错误');
                })
                .finally(() => {
                    formLoading.value = false;
                });
            await storeLoginModal.handleLoginSuccess((res as any).token);
        };

        /**
         * created
         */
        storeCaptcha.getCaptchaInfo();

        return () => (
            <Form model={formState} ref={formRef}>
                <FormItem name='loginName' rules={[{ required: true, message: '请输入账号或手机号', trigger: 'blur' }]}>
                    <Input
                        v-model:value={formState.loginName}
                        placeholder='请输入账号或手机号'
                        autocomplete='off'
                        v-slots={{ prefix: () => <UserOutlined /> }}
                    />
                </FormItem>
                <FormItem name='password' rules={[{ required: true, message: '请输入密码', trigger: 'blur' }]}>
                    <InputPassword
                        v-model:value={formState.password}
                        placeholder='请输入密码'
                        autocomplete='off'
                        v-slots={{ prefix: () => <LockOutlined /> }}
                    />
                </FormItem>
                <div class='captcha-content g-flex'>
                    <FormItem class='g-flex-1' name='code' rules={[{ required: true, message: '请输入验证码', trigger: 'blur' }]}>
                        <Input v-model:value={formState.code} onPressEnter={handleSubmit} placeholder='请输入验证码' autocomplete='off' />
                    </FormItem>
                    <div class='captcha-content__img g-relative g-flex-shrink-0' onClick={storeCaptcha.getCaptchaInfo}>
                        {storeCaptcha.captchaInfo.img ? (
                            <>
                                <img class='g-h-full g-w-full' src={storeCaptcha.captchaInfo.img} />
                                {storeCaptcha.isExpired ? (
                                    <div class='captcha-content__img-mask g-absolute g-left-[0] g-top-[0] g-h-full g-w-full g-flex g-items-center g-justify-center'>
                                        <SvgIcon name='reload' />
                                    </div>
                                ) : null}
                            </>
                        ) : null}
                    </div>
                </div>
                <div
                    class='g-mb-[18px] g-cursor-pointer g-text-align-right g-font-size-[14px] g-color-[#757575] g-line-height-[12px]'
                    onClick={() => {
                        context.emit('setKey', '手机号注册');
                    }}
                >
                    <span>手机号注册</span>
                </div>
                <Button
                    type='primary'
                    class='g-h-[44px] g-w-full g-rounded-[22px] g-p-[0] g-font-size-[15px]'
                    onClick={handleSubmit}
                    loading={formLoading.value}
                >
                    登录
                </Button>
            </Form>
        );
    },
});
